export default __webpack_public_path__ + "static/media/usb1.729ca7ca.png";